<script setup>
import { ref } from 'vue'

const props = defineProps(['model'])
const { showFooterForm } = useLayoutFlags()
showFooterForm.value = true

const categoryGuid = props.model?.contentLink?.guidValue

// Transform breadcrumb data to match BreadCrumb component properties
const transformedBreadcrumbs = computed(() => {
  if (!props.model?.breadcrumbLinks?.value || props.model.breadcrumbLinks.value.length === 0) {
    return []
  }

  return props.model.breadcrumbLinks.value.map(item => ({
    label: item.text,
    to: item.href,
    id: item.contentLink?.id,
  }))
})

const questionListings = ref([])

// Fetch questions from API using the content link ID
const { data: questionListingsResponse, error: fetchError } = await useFetch('/api/questions/questionListingsByCategory', {
  query: {
    categoryGuid,
  },
  method: 'GET',
})

if (fetchError.value) {
  console.error('Failed to fetch questions:', fetchError.value)
  questionListings.value = []
}

if (questionListingsResponse.value) {
  questionListings.value = questionListingsResponse?.value?.length ? questionListingsResponse.value : []
}
</script>

<template>
  <div class="question-category-page">
    <div class="container-fluid">
      <div class="main-body">
        <PageHeader
          :title="model.pageTitle.value"
          :description="model.categorySubhead.value"
          custom-bottom-space="mb-0"
          bottom-border
        >
          <BreadCrumb
            v-if="transformedBreadcrumbs.length > 0"
            :items="transformedBreadcrumbs"
          />
        </PageHeader>
        <QuestionsBlock
          v-for="(ql, i) in questionListings"
          :key="i"
          :title="ql.title"
          :summary="ql.summary"
          :icon-src="ql.iconSource"
          :icon-alt-text="ql.iconAltText"
          :questions="ql.questionList"
          width="wide"
          custom-bottom-space="mb-0"
          bottom-border
        />
      </div>
    </div>

    <div class="page-block-area flex flex-col items-center justify-center w-full">
      <GenericsContentArea :model="model.pageBlockArea.expandedValue" />
    </div>
  </div>
</template>

<style lang="scss">
@use '@/assets/css/pages/general-page.scss';
</style>
